/**
 * The quieter install surfaces (docs/mockups/install.html, C and Desktop) and the
 * offline strip: the row at the foot of Stats, the desktop button beside the streak.
 * (The ⋯ menu line is a `MenuItem`, built in Today.)
 */
import { useEffect } from 'react';

import { noteSurfaceShown } from '../../pwa/install.ts';
import { InstallIcon, Wedge } from '../icons.tsx';
import { DartTile } from '../DartMark.tsx';
import { Nib } from '../Nib.tsx';
import '../../styles/install.css';

/** The line's words: "Add to home screen", or on a computer, the Dock / an app window. */
export function lineCopy(route: string | null, desktop: boolean): { label: string; sub: string } {
	if (route === 'mac_safari') return { label: 'Add to Dock', sub: 'In Safari: File, then Add to Dock.' };
	if (desktop) return { label: 'Add to your computer', sub: 'Opens in its own window, like an app.' };
	return { label: 'Add to home screen', sub: 'Opens like an app.' };
}

/** C · a printed row at the foot of Stats, where people who care about their streak already look. */
export function InstallRow({ label, sub, onAdd }: { label: string; sub: string; onAdd: () => void }) {
	useEffect(() => noteSurfaceShown('stats_row'), []);
	return (
		<button type="button" className="qrow" onClick={onAdd} data-testid="install-row">
			<DartTile className="ic" />
			<span className="t">
				{label}
				<small>{sub}</small>
			</span>
			<span className="go" aria-hidden="true">
				<Wedge direction="right" />
			</span>
		</button>
	);
}

/** Desktop Chrome / Edge, holding a prompt: a small button beside the streak. */
export function DesktopInstall({ onClick }: { onClick: () => void }) {
	useEffect(() => noteSurfaceShown('desktop_button'), []);
	return (
		<button type="button" className="dinst" onClick={onClick} data-testid="desktop-install">
			<InstallIcon.down />
			Install
		</button>
	);
}

/** Offline, on Today: worried Nib on a printed strip (stock, ink keyline: butter is too rare to spend here). The game itself never mentions the network. */
export function OfflineStrip() {
	return (
		<div className="offl" role="status" data-testid="offline-strip">
			<Nib pose="worried" className="nb" />
			<p>
				<b>You’re offline.</b>
				<span>Today’s puzzles still work, and your progress is saved.</span>
			</p>
		</div>
	);
}
